import React, { Fragment } from 'react'

import { Form, Formik } from 'formik'
import useFormValues from './useFormValues'
import { Attachment } from '@/checkout-instore-legacy/product/typings'
import { Button, TextInput, csx } from '@vtex/admin-ui'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'

export interface SubmitProps {
  attachmentId: string
  content: Record<string, string>
}

interface AttachmentFormProps {
  attachment: Attachment
  initialValues?: SubmitProps
  formSubmitLabel?: string
  onSubmit: (values: SubmitProps) => void
}

export const AttachmentForm = ({
  attachment,
  initialValues,
  formSubmitLabel = 'attachments.modal.save-and-add-to-cart',
  onSubmit,
}: AttachmentFormProps) => {
  const intl = useIntl()

  const { id, inputValues, required } = attachment

  const { formInitialValues, schemaValidationError } = useFormValues({
    inputValues: inputValues,
    initialValues,
    isRequired: required,
  })

  return (
    <div
      data-testid="attachments-form"
      className={csx({ marginY: '$space-4', paddingX: '$space-6' })}
    >
      <Formik
        validationSchema={schemaValidationError}
        initialValues={formInitialValues}
        validateOnMount
        enableReinitialize
        onSubmit={(values) => {
          const formValues: SubmitProps = {
            attachmentId: id,
            content: values,
          }

          onSubmit && onSubmit(formValues)
        }}
      >
        {({ values, handleChange, handleBlur, isValid }) => (
          <Form>
            {inputValues?.map((inputValue, index) => {
              if (inputValue.type === 'TEXT') {
                return (
                  <Fragment key={inputValue.label}>
                    <TextInput
                      data-testid={`attachments-form-input-${index}`}
                      name={inputValue.label}
                      label={inputValue.label}
                      maxLength={inputValue.maxLength}
                      value={(values as any)[inputValue.label]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Fragment>
                )
              }

              return null
            })}

            <Button
              data-testid="attachments-form-button-save"
              disabled={required && !isValid}
              size="large"
              type="submit"
              className={csx({
                width: '100%',
                height: '3rem',
                marginTop: '$space-4',
              })}
            >
              {intl.formatMessage({
                id: formSubmitLabel,
              })}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}
